import { useIntegrationsLayout } from 'app/components/integrations-layout/useIntegrationsLayout'
import { IntegrationsLayoutShadcnComponent } from 'app/components/integrations-layout/IntegrationsLayoutShadcnComponent'

export const handle = {
  title: `Integrations`,
  breadcrumb: `Integrations`,
}

export default function Integrations() {
  const { tabs, primaryButtonSlot } = useIntegrationsLayout()
  return <IntegrationsLayoutShadcnComponent tabs={tabs} primaryButtonSlot={primaryButtonSlot} />
}
